import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    list: -1,
  },
  list: [],
  meta: null,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;
  const isLoadMore = meta?.isLoadMore ?? false;

  switch (type) {
    // getFiles
    case ACTION_TYPES.FILES_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          list: -1,
        },
        error: null,
      };

    case ACTION_TYPES.FILES_GET_SUCCEED:
      return {
        ...state,
        list: isLoadMore ? [...state.list, ...payload.data] : payload.data,
        meta: payload.meta,
        status: {
          ...state.status,
          list: 1,
        },
        error: null,
      };

    case ACTION_TYPES.FILES_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          list: 2,
        },
        error,
      };

    default:
      return state;
  }
}
